import Index from './common/pages/index'
import NotFound from './common/pages/not_found'
import Error from './common/pages/error'

import AdminRoutes from './admin/routes'
import SPRoutes from './su/routes'
import EPRoutes from './ep/routes'

export default [
  // vue-router 4 の redirect は遷移先を返さないとエラーになるので、ガードで外部へ飛ばして遷移を止める
  { path: '/', component: NotFound, beforeEnter: () => { window.location.href = 'https://www.sixbrain.ai/'; return false; }, meta: { isPublic: true }},
  { path: '/error', component: Error, meta: { isPublic: true }},
].concat(AdminRoutes, SPRoutes, EPRoutes, [
  // vue-router 4 では '*' が使えない
  { path: '/:pathMatch(.*)*', component: NotFound, meta: { isPublic: true }}
]);
